<template>
  <span>
    <router-link :to="{ name: 'completed_tasks' }" class="text-muted" title="filter by date">
      <i class="material-icons">date_range</i>
    </router-link>
      <router-link :to="{ name: 'completed_tasks_by_project' }" title="filter by project" class="text-muted">
      <i class="material-icons">work</i>
    </router-link>
    <router-link :to="{ name: 'contact_completed_tasks' }" title="filter by contact" class="text-muted">
      <i class="material-icons">contacts</i>
    </router-link>
    <router-link :to="{ name: 'tag_completed_tasks' }" title="filter by tag" class="text-muted">
      <i class="material-icons">label_outline</i>
    </router-link>
    <TaskExpander />
  </span>
</template>

<script>
import TaskExpander from "components/TaskExpander";

export default {
  components: {
    TaskExpander
  }
};
</script>
